import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavItem } from '../../index';

const Tabs = ({
  tabs,
  isFullWidth = false,
  className = '',
  style = {}
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames('tabs', className),
  style: {
    width: isFullWidth ? '100%' : 'auto',
    ...style
  }
}, tabs.map(({
  icon,
  label,
  path
}) => /*#__PURE__*/React.createElement(NavItem, {
  className: "tab-item",
  key: path,
  label: label,
  icon: icon,
  to: path
})));

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    icon: PropTypes.string,
    label: PropTypes.string.isRequired,
    to: PropTypes.string
  })),
  isFullWidth: PropTypes.bool
};
export default Tabs;